const initialState = {
  topics: [],
  isLoading: null,
  isError: null,
};

export default initialState;
